export const ConfirmationDialogMessages = {
    b2c: {
        manageBooking: {
            cancelOrder: {
                title: 'Are you sure you want to cancel the order?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    cancelOrderAnyways: 'Cancel Order Anyways',
                },
            },
            modifyBooking: {
                title: 'Are you sure you want to modify the order?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    saveOrder: 'Save Order',
                },
            },
            removeTour: {
                title: 'Are you sure you want to remove this tour?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    removeTour: 'Remove Tour',
                },
            },
        },
        profile: {
            updateProfile: {
                title: 'Are you sure you want to update your profile?',
                description:
                    'Once you update your profile, you will loose the older information.',
                buttons: {
                    cancel: 'Cancel',
                    saveChanges: 'Save Changes',
                },
            },
        },
        payments: {
            removePaymentMethod: {
                title: 'Are you sure you want to remove this card?',
                description: '',
                buttons: {
                    cancel: 'Cancel',
                    removeCard: 'Remove Card',
                },
            },
        },
    },
    agent: {
        manageBooking: {
            cancelOrder: {
                title: 'Are you sure you want to cancel the order?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    cancelOrderAnyways: 'Cancel Order Anyways',
                },
            },
            modifyBooking: {
                title: 'Are you sure you want to modify the order?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    saveOrder: 'Save Order',
                },
            },
            removeTour: {
                title: 'Are you sure you want to remove this tour?',
                description:
                    'All seats will be released and rebooking is Not guaranteed',
                buttons: {
                    backToBooking: 'Back to Booking',
                    removeTour: 'Remove Tour',
                },
            },
        },
        profile: {
            updateProfile: {
                title: 'Are you sure you want to update your profile?',
                description:
                    'Once you update your profile, you will loose the older information.',
                buttons: {
                    cancel: 'Cancel',
                    saveChanges: 'Save Changes',
                },
            },
            removeUser: {
                title: 'Are you sure you want to remove this user?',
                description:
                    'Once the agent is removed, you will have to add them back to see them in this list again.',
                buttons: {
                    cancel: 'Cancel',
                    removeUser: 'Remove User',
                },
            },
        },
    },
};

export const ErrorDialogMessages = {
    agent: {
        profile: {
            editIncompleteProfile: {
                title: 'Incomplete Profile',
                description: 'Please fill out all required fields.',
                buttons: {
                    close: 'Close',
                },
            },
            updateProfileError: {
                title: 'Unable to update profile',
                description: 'Something went wrong, please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
        },
    },
    b2c: {
        profile: {
            editIncompleteProfile: {
                title: 'Incomplete Profile',
                description: 'Please fill out all required fields.',
                buttons: {
                    close: 'Close',
                },
            },
            updateProfileError: {
                title: 'Unable to update profile',
                description: 'Something went wrong, please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
        },
        bookingOVerview: {
            loadBookingsError: {
                title: 'Failed to load bookings',
                description: 'Something went wrong, please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
        },
        manageBooking: {
            loadBookingError: {
                title: 'Failed to load booking',
                description: 'Something went wrong, please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
        },
        payments: {
            editPaymentMethodIncompleteForm: {
                title: 'Missing Information',
                description: 'Please fill out all required fields.',
                buttons: {
                    close: 'Close',
                },
            },
            editPaymentMethodError: {
                title: 'Unable to edit Payment Method',
                description: 'Please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
            addNewPaymentMethodIncompleteForm: {
                title: 'Missing Information',
                description: 'Please fill out all required fields.',
                buttons: {
                    close: 'Close',
                },
            },
            addNewPaymentMethodError: {
                title: 'Unable to edit add new Payment Method',
                description: 'Please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
            updatePrimaryPaymentMethodError: {
                title: 'Unable to update primary Payment Method',
                description: 'Please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
        },
    },
    public: {
        excursion: {
            excursionNotFound: {
                title: 'Tour not found',
                description:
                    "We're unable to find the data you're looking for.",
                buttons: {
                    close: 'Close',
                },
            },
        },
        cart: {
            incompleteLeadTraveler: {
                title: 'Missing Information',
                description:
                    'Enter lead traveler information to continue to checkout',
                buttons: {
                    backToCart: 'Back to Cart',
                },
            },
            invalidParticipants: {
                title: 'Missing Information',
                description:
                    'Some booking contains no participants. Remove the booking or add a participant to continue to checkout',
                buttons: {
                    backToCart: 'Back to Cart',
                },
            },
        },
        checkout: {
            incompleteForm: {
                title: 'Missing Information',
                description:
                    'Fill out all required fields to complete your booking',
                buttons: {
                    close: 'Close',
                },
            },
            // when users navigate to checkout with an empty cart
            // this error message will be displayed and the user will
            // be redirected to the search page
            cartIsEmpty: {
                title: 'Empty Cart',
                description: "You haven't added any tours to your cart",
                buttons: {
                    backToShopping: 'Back to Shopping',
                },
            },
            // when users navigate to checkout with an invalid cart
            // this error message will be displayed and the user will
            // be redirected to the cart page
            incompleteLeadTraveler: {
                title: 'Missing Information',
                description:
                    'Enter lead traveler information to continue to checkout',
                buttons: {
                    backToCart: 'Back to Cart',
                },
            },
            invalidParticipants: {
                title: 'Missing Information',
                description:
                    'Some booking contains no participants. Remove the booking or add a participant to continue to checkout',
                buttons: {
                    backToCart: 'Back to Cart',
                },
            },

            saveBookingError: {
                title: 'Unable to submit booking',
                description: 'Please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
            retrieveTicketCreateAccountFail: {
                title: 'Unable to create account',
                description: 'Your booking is saved',
                buttons: {
                    close: 'Close',
                },
            },
        },
        bookingConfirmation: {
            resendEmailError: {
                title: 'Unable to resend email',
                description: 'Please try again later.',
                buttons: {
                    close: 'Close',
                },
            },
            bookingNotFound: {
                title: 'Booking not found',
                description:
                    "We're unable to find the data you're looking for.",
                buttons: {
                    close: 'Close',
                },
            },
        },
    },
};

export const SuccessDialogMessages = {
    public: {
        checkout: {
            bookingConfirmed: {
                title: 'Booking is confirmed',
                description:
                    'Thank you for booking this adventure with us! CruiseCode and Alaska X are proud to be part of your travel plans. We hope you have an incredible trip, and we appreciate your business.',
                buttons: {
                    login: 'Login',
                    viewBooking: 'View Booking',
                },
            },
        },
    },
    b2c: {
        payments: {
            editPaymentMethodSuccess: {
                title: 'Payment Method Updated',
                description: '',
                buttons: {
                    close: 'Close',
                },
            },
            addNewPaymentMethodSuccess: {
                title: 'Payment Method Updated',
                description: '',
                buttons: {
                    close: 'Close',
                },
            },
            updatePrimaryPaymentMethodSucces: {
                title: 'Primary Payment Method Updated',
                description: '',
                buttons: {
                    close: 'Close',
                },
            },
        },
    },
};
